export const getErrorMessage = (error, t, fallbackMessage = 'Une erreur est survenue') => {
  if (!error) {
    return fallbackMessage;
  }

  const response = error.response;
  if (response?.data?.error) {
    return response.data.error;
  }
  if (response?.data?.message) {
    return response.data.message;
  }
  if (response?.data?.errors && Array.isArray(response.data.errors)) {
    return response.data.errors
      .map((err) => err.msg || err.message)
      .filter(Boolean)
      .join(', ');
  }

  if (response?.status === 403) {
    return t ? t('errors.forbidden') : 'Session expirée. Veuillez vous reconnecter.';
  }

  return error.message || fallbackMessage;
};
